import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/index.ts";
import { fetchFavoriteGames } from "../../store/gamesSlice.js";
import { GAME_COUNT } from "../../store/enums.js";
import { useLocation } from "react-router-dom";

export default function useFillFavorites(isActive) {
  const dispatch = useDispatch();
  const currency = useAppSelector((state) => state.user.currency);
  const userId = useAppSelector((state) => state.user.userId);
  const location = useLocation();

  const countGames = location.pathname == "/games/favorites" ? 0 : GAME_COUNT;

  useEffect(() => {
    if (!isActive) return;
    if (!currency || !userId) return;
    dispatch(fetchFavoriteGames({ countGames, currency }));
  }, [userId, currency, countGames, dispatch, isActive]);
}
